import { Complaint as IComplaintRaw } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IComplaint, ComplaintSource } from "./complaint.types"
import { Complaint } from "./complaint"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"

type ComplaintRaw = IComplaintRaw

const parseSource = (
  sourceRaw?: string | null,
): ComplaintSource | undefined => {
  if (sourceRaw === "FRESHDESK" || sourceRaw === "AWS_CONNECT") {
    return sourceRaw
  }
  return undefined
}

export const ComplaintParser: IParser<IComplaint, ComplaintRaw> = {
  toDomain: (data: ComplaintRaw): IComplaint => {
    try {
      return new Complaint(
        data.id,
        dayjs(data.created_at),
        dayjs(data.updated_at),
        data.external_identifier + "",
        parseSource(data.source),
        safeDayjs(data.closed_at),
        safeDayjs(data.deleted),
        data.team ?? undefined,
        data.agent_email ?? undefined,
        data.agent_name ?? undefined,
        data.ombudsman_case ?? undefined,
        data.customer_id ?? undefined,
        data.type ?? undefined,
        data.d1_signposting_comms_sent ?? undefined,
        safeDayjs(data.send_date_of_d1_signposting_comms),
        data.d56_signposting_comms_sent ?? undefined,
        safeDayjs(data.send_date_of_d56_signposting_comms),
        data.deadlock_comms_sent ?? undefined,
        data.complaints_goodwill_amount ?? undefined,
        data.category1 ?? undefined,
        data.category2 ?? undefined,
        data.category3 ?? undefined,
        data.channel ?? undefined,
        safeDayjs(data.date_raised),
        data.status ?? undefined,
        data.sub_status ?? undefined,
        data.ofgem_mapped_complaint_category ?? undefined,
        data.internal_complaint_category ?? undefined,
        data.details?.complaintId ?? undefined,
        data.details?.contactEmail ?? undefined,
        data.details?.complaintsCustPrefContactMeth ?? undefined,
        data.details?.billingAccountIds ?? undefined,
        data.details?.billingAccountNumber ?? undefined,
        safeDayjs(data.details?.send_date_of_recent_signposting_comms),
        safeDayjs(data.details?.send_date_of_overdue_signposting_comms),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
